import { Link } from 'react-router-dom';
import plusNav from './plusNav.js';
import AppHeader from '../components/layout/AppHeader.jsx';

/**
 * BOS+ expansion (additive) — the `/plus` launcher.
 *
 * A deterministic entry point that lists every installed plus module from
 * `plusNav.js`. Each entry renders a link carrying its `data-testid`, giving
 * e2e a stable way to reach any future module. Static page (no data fetch), so
 * it exposes `data-loading="false"` immediately for deterministic waits.
 */
export default function PlusLauncher() {
  return (
    <div className="plus-launcher" data-testid="plus-launcher-page" data-loading="false">
      <AppHeader />
      <main className="hr-main">
        <h1>BOS+ Modules</h1>
        <p className="muted">Expansion modules installed on this platform.</p>
        {plusNav.length === 0 ? (
          <p data-testid="plus-nav-empty">No expansion modules installed yet.</p>
        ) : (
          <ul className="plus-nav-list" data-testid="plus-nav-list">
            {plusNav.map((n) => (
              <li key={n.key}>
                <Link to={n.path} data-testid={n.testid}>
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        )}
      </main>
    </div>
  );
}
